import './editorial-50-50.scss';
import { debounce } from 'lodash';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { headerHeight } from '../../scripts/helpers';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initEditorial5050 = (context) => {
  const Editorial5050 = context.closest('.shopify-section');
  if (!Editorial5050) return;

  gsap.registerPlugin(ScrollTrigger);

  const stickyText = Editorial5050.querySelector(
    '.editorial-50-50__text-block',
  );
  const container = Editorial5050.querySelector('.editorial-50-50');
  if (!stickyText || !container) return;
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.editorial-50-50'), (el) => {
    window.dAgency.initEditorial5050(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.editorial-50-50'), (el) => {
      window.dAgency.initEditorial5050(el);
    });
  });
}
